import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";
import { getGetOpportunityByIdQueryOptions } from "@fp/admin-api-client/client";
import {
	PageContentContainer,
	PageLoading,
} from "@fp/ui/components/base/page-layout/page-layout";
import {
	OpportunityEditForm,
	OpportunityEditFormContent,
	transformOpportunityToFormValues,
} from "@fp/ui/components/opportunities/opportunity-edit-form";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const Route = createFileRoute("/opps/$oppId/edit/")({
	component: RouteComponent,
	loader: async ({ params, context: { queryClient } }) => {
		const opportunity = await queryClient.fetchQuery(
			getGetOpportunityByIdQueryOptions(params.oppId),
		);

		return opportunity.data;
	},
	pendingComponent: () => <PageLoading />,
});

function RouteComponent() {
	const opportunity = Route.useLoaderData();
	const router = useRouter();
	const params = Route.useParams();
	const queryClient = useQueryClient();

	const defaultValues = transformOpportunityToFormValues(opportunity);

	const onSuccess = useCallback(async () => {
		await queryClient.invalidateQueries({
			queryKey: getGetOpportunityByIdQueryOptions(params.oppId).queryKey,
		});
		await router.invalidate({ sync: true });
		router.navigate({
			to: "/opps/$oppId",
			params: { oppId: params.oppId },
		});
	}, [router, params.oppId, queryClient]);

	return (
		<AdminLayout>
			<AdminPageHeader
				title="Edit Opp"
				parent={{
					url: router.buildLocation({
						to: "/opps/$oppId",
						params: { oppId: params.oppId },
					}).href,
					label: "Opp Detail",
				}}
			/>
			<PageContentContainer className="space-y-6">
				<OpportunityEditForm
					defaultValues={defaultValues}
					onSuccess={onSuccess}
				>
					<OpportunityEditFormContent />
				</OpportunityEditForm>
			</PageContentContainer>
		</AdminLayout>
	);
}
